import PublishReportCard from "../molecules/PublishReportCard";
import { DashboardCard } from "../molecules/DashboardCard";
import { useTranslation } from "react-i18next";
import NoResult from "../molecules/NoResult";
import { CenterSpinner } from "../atoms/spinner";
import { dateDiff } from "~/helpers/date";
import { useUserContext } from "~/hooks/useUserContext";
import { PlatformRole } from "~/config/types";
import { useDocumentVersions } from "../api/v2/useDocumentVersions";
import { DocumentVersionStatus } from "../config/types";
import { cn } from "~/lib/utils";

const PublishReportContainer = () => {
  const { t } = useTranslation();
  const { user } = useUserContext();

  const { data: documentVersions } = useDocumentVersions({
    statuses: [DocumentVersionStatus.published],
  });

  const documentVersionsWithReaders = documentVersions
    ?.filter((v) => v.readers.totalCount > 0)
    .filter((v) => {
      if (user.role === PlatformRole.contributor) {
        return v.document.owner.userId === user.id;
      }
      return true;
    })
    .sort((a, b) => dateDiff(b.publishedAt, a.publishedAt));

  const title = t(($) => $.dashboard.publish.title);

  if (documentVersionsWithReaders === undefined) {
    return (
      <DashboardCard title={title} className="h-80">
        <CenterSpinner />
      </DashboardCard>
    );
  }

  if (documentVersionsWithReaders?.length === 0) {
    return (
      <DashboardCard title={title}>
        <NoResult className="h-full" />
      </DashboardCard>
    );
  }

  return (
    <DashboardCard title={title}>
      <div className={cn("flex gap-4 overflow-auto pb-4 xl:flex-wrap")}>
        {documentVersionsWithReaders.map((i) => (
          <PublishReportCard data={i} key={i.id} />
        ))}
      </div>
    </DashboardCard>
  );
};

export default PublishReportContainer;
